/// <amd-module name="Widgets/QueryResultsWidget/clients/WorkItemTracking" />
/**
 * ---------------------------------------------------------
 * Generated file, DO NOT EDIT
 * ---------------------------------------------------------
 *
 * See following wiki page for instructions on how to regenerate:
 *   https://aka.ms/azure-devops-client-generation
 *
 * Configuration file:
 *   tfs\web\extensions\dashboards\widgets\query-results-widget-content\genclient.json
 */

import { IVssPageContext, IVssRestClientOptions, RestClients } from "VSS/Platform/Context";
import { RestClientBase } from "VSS/Platform/RestClientBase";

import * as Dashboards_WorkItemTracking_Contracts from "Dashboards/Clients/Contracts/WorkItemTracking";

import { IWorkItemTrackingRestClient } from "Widgets/QueryResultsWidget/clients/WorkItemTracking.Types";

export { IWorkItemTrackingRestClient } from "Widgets/QueryResultsWidget/clients/WorkItemTracking.Types";

class WorkItemTrackingRestClient extends RestClientBase implements IWorkItemTrackingRestClient {
    constructor(options: IVssRestClientOptions) {
        super(options);
    }

    /**
     * Gets the results of the query given the query ID.
     * 
     * @param id - The query ID.
     * @param project - Project ID or project name
     * @param team - Team ID or team name
     * @param timePrecision - Whether or not to use time precision.
     * @param top - The max number of results to return.
     */
    public async queryById(
        id: string,
        project?: string,
        team?: string,
        timePrecision?: boolean,
        top?: number
        ): Promise<Dashboards_WorkItemTracking_Contracts.WorkItemQueryResult> {

        const queryValues: any = {
            timePrecision: timePrecision,
            '$top': top
        };

        return this.beginRequest<Dashboards_WorkItemTracking_Contracts.WorkItemQueryResult>({
            apiVersion: "5.0-preview.2",
            routeTemplate: "{project}/{team}/_apis/wit/wiql/{id}",
            routeValues: {
                project: project,
                team: team,
                id: id
            },
            queryParams: queryValues
        });
    }

}

export const WorkItemTrackingClientName = "QueryResultsWidget-Wit.IWorkItemTrackingRestClient";

export function getWorkItemTrackingClient(pageContext: IVssPageContext, options?: IVssRestClientOptions): IWorkItemTrackingRestClient {
    return pageContext.getRestClient<IWorkItemTrackingRestClient>(WorkItemTrackingClientName, options);
}

RestClients.add(WorkItemTrackingClientName, { 
    factory: WorkItemTrackingRestClient,
    options: {
        resourceAreaId: "5264459e-e5e0-4bd8-b118-0985e68a4ec5",
        serviceInstanceType: "00025394-6065-48ca-87d9-7f5672854ef7"
    }
});
